export const FOS_POLICY_27825 = process.env.REACT_APP_FOS_POLICY_FORMA_27825 === 'true';